// src/components/Navbar.js
import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import "./Navbar.css";

const NAV_LINKS = [
  { to: "/dashboard", label: "Dashboard", icon: "⚡" },
  { to: "/history", label: "History", icon: "📜" },
  { to: "/settings", label: "Settings", icon: "⚙️" },
];

export default function Navbar() {
  const { user, userData, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  if (!user) return null;

  const plan = userData?.plan || "free";
  const isProUser = plan === "pro";

  const used = isProUser
    ? userData?.videosUsedMonth || 0
    : userData?.videosUsedToday || 0;

  const limit = isProUser ? 100 : 5;

  const periodLabel = isProUser ? "month" : "week";

  return (
    <nav className="navbar">
      <div className="navbar-inner">
        <Link to="/dashboard" className="navbar-logo">
            <img src="/creatorcomment-logo.png" alt="CreatorComment Logo" className="logo-img" />
        </Link>

        <div className="navbar-links">
          {NAV_LINKS.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`nav-link ${location.pathname === link.to ? "active" : ""}`}
            >
              <span>{link.icon}</span>
              {link.label}
            </Link>
          ))}
        </div>

        <div className="navbar-right">
          <div className="usage-pill">
            <span className="glow-dot" />
            <span>{used}/{limit} this {periodLabel}</span>
          </div>


          {plan === "free" && (
            <Link to="/settings/#plan" className="btn btn-primary" style={{ fontSize: 13, padding: "7px 14px" }}>
              ✦ Upgrade
            </Link>
          )}

          <div className="avatar-menu">
            <img
              src={user?.photoURL || `https://ui-avatars.com/api/?name=${user.displayName}&background=6f6af8&color=fff`}
              alt="avatar"
              className="avatar"
            />
            <div className="avatar-dropdown">
              <div className="dropdown-user">
                <strong>{user?.displayName}</strong>
                <span>{user?.email}</span>
              </div>
              <div className="dropdown-divider" />
              <Link to="/settings" className="dropdown-item">⚙️ Settings</Link>
              <button onClick={handleLogout} className="dropdown-item danger">⇥ Sign out</button>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}